import type { Playback } from "../types/Playback"

// Frame indices in the order the downloaded file plays them. Ping-pong shows both end frames
// twice, as the server's encoder does (Converters::Encoders::Ani).
export const playbackSequence = (frameCount: number, playback: Playback) => {
  const forward = Array.from({ length: frameCount }, (_, index) => index)
  if (playback === "reverse") return forward.reverse()
  if (playback === "pingpong") return [...forward, ...[...forward].reverse()]

  return forward
}
